import React from 'react';
import './Header.css';
import * as oauthjs from '../../auth/oauth';

class HeaderXA3 extends React.Component {
    constructor(props) {
        super(props);
        this.getSigninurl = this.getSigninurl.bind(this);
    }

    getSigninurl() {
        let clientId = 'xfinitychat';
        let url = oauthjs.getLoginUrl({
            clientId: clientId,
            authorizeUrl: 'https://login.comcast.net/oauth/authorize',
            iframeRedirectUri: '/chat/',
            authOpts: {
                redirect_uri: '/chat/',
            },
        });
        return url;
    }
    render() {
        let signinurl = this.getSigninurl();
        return (
            <xc-header
                aria-hidden="true"
                tabIndex="-1"
                client-id="xfinitychat"
                id="xfinitychatHeader"
                sign-in-url={signinurl}
                enable-notifications
                auto-auth
            ></xc-header>
        );
    }
}

export default HeaderXA3;
